import Api from './api';

const PesquisaService = {
    cadastro: async (params) => {
        const response = await Api.post('/pesquisa/cadastrar', params)
        return response
    },
    media: async (params) => {
        const response = await Api.get(`/pesquisa/mediasorgao?${params}`)
        return response
    },
    orgao: async (params) => {
        const response = await Api.get(`/pesquisa/notasorgao?${params}`)
        return response
    }
}

export default PesquisaService;